import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import { MOMENT_TIME_FORMAT } from '../../helpers/constants';
import { FormGroup } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS } from '../../helpers/formGroupVariants';

const SessionCountDown = () => {
    const tokenValidUntil = useSelector(state => state.user.loggedInUser.tokenValidUntil);
    
    const [timeRemaining, setTimeRemaining] = useState(getTimeRemaining(tokenValidUntil));

    function getTimeRemaining(validUntil) {
        const d = new Date();
        const d2 = new Date(validUntil);
        const milSec = d2 - d;
        const d3 = new Date(milSec);
        return {
            seconds: (Math.floor(d3 / 1000)) % 60,
            minutes: (Math.floor(d3 / 1000 / 60)) % 60,
            hours: (Math.floor(d3 / 1000 / 60 / 60)) % 24,
        };
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeRemaining(getTimeRemaining(tokenValidUntil));
        }, 1000);
        return () => clearInterval(interval);
    }, [tokenValidUntil]);

    // Create a Date object from timeRemaining for moment formatting
    const timeRemainingDate = new Date();
    timeRemainingDate.setHours(timeRemaining.hours, timeRemaining.minutes, timeRemaining.seconds);
    const sessionLabel = CONTENT_STRINGS.SESSION_EXPIRES_IN + (moment(timeRemainingDate).isValid() ? moment(timeRemainingDate).format(MOMENT_TIME_FORMAT) : '');
    return (
        <FormGroup
            labelSize={'col-sm-12'}
            inputSize={'col-sm-offset-12'}
            label={sessionLabel}
            variant={FORM_GROUP_VARIANTS.PLAIN}
            inputProps={{
                id: 'session-countdown-timer-id',
                name: 'session-countdown-timer-name',
            }}
            formGroupTestId={'session-timer'}
        />
    );
};

export default SessionCountDown;